import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
	CreatePicTimeGallery,
	GetRedirectPicTimeUrl,
	JobMetadata,
	PicTimeActions,
	PicTimeDataResponse,
	PicTimeGalleriesForImport,
	PicTimeGalleriesResponse,
	PreFillPicTimeData,
	ServerDataResponse
} from '@models/models';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class PickTimeDataProvider {
	constructor(private http: HttpClient) {}

	initPickTimeIntegration(
		domainName: string
	): Observable<ServerDataResponse<PicTimeDataResponse>> {
		const PICK_TIME_INTEGRATION_URL = '/api/user/pictime/connect?domainName=';
		return this.http.get<ServerDataResponse<PicTimeDataResponse>>(
			PICK_TIME_INTEGRATION_URL + domainName
		);
	}

	savePickTimeIntegration(
		authObj: object
	): Observable<ServerDataResponse<null>> {
		const SAVE_PICK_TIME_INTEGRATION_URL =
			'/api/user/integrations/pictime/oauth';
		return this.http.post<ServerDataResponse<null>>(
			SAVE_PICK_TIME_INTEGRATION_URL,
			authObj
		);
	}

	updatePicTimeIntegration(data): Observable<ServerDataResponse<null>> {
		const UPDATE_PIC_TIME_INTEGRATION_URL = '/api/user/pictime/update';
		return this.http.put<ServerDataResponse<null>>(
			UPDATE_PIC_TIME_INTEGRATION_URL,
			data
		);
	}

	getPreFillPicTimeSettings(): Observable<
		ServerDataResponse<PreFillPicTimeData>
	> {
		const url = '/api/user/integrations/pictime';
		return this.http.get<ServerDataResponse<PreFillPicTimeData>>(url);
	}

	disconnectPickTimeIntegration(
		url: string
	): Observable<ServerDataResponse<null>> {
		return this.http.post<ServerDataResponse<null>>(url, null);
	}

	getPicTimeActions(jobId): Observable<ServerDataResponse<PicTimeActions>> {
		const url = `/api/user/pictime/job/${jobId}/gallery/overview`;
		return this.http.get<ServerDataResponse<PicTimeActions>>(url);
	}

	getImportPicTimeGalleries(): Observable<
		ServerDataResponse<PicTimeGalleriesForImport[]>
	> {
		const url = '/api/user/pictime/gallery-for-import/get';
		return this.http.get<ServerDataResponse<PicTimeGalleriesForImport[]>>(url);
	}

	getPicTimeGalleries(
		jobId
	): Observable<ServerDataResponse<PicTimeGalleriesResponse[]>> {
		const url = `/api/user/pictime/job/${jobId}/galleries/get`;
		return this.http.get<ServerDataResponse<PicTimeGalleriesResponse[]>>(url);
	}

	syncPicTimeGallery(
		url: string,
		method: string
	): Observable<ServerDataResponse<boolean>> {
		return this.http[method.toLowerCase()](url, {});
	}

	importSelectedPicTimeGalleries(
		jobId,
		selectedPicTimeGalleriesToSend
	): Observable<ServerDataResponse<null>> {
		const url = `/api/user/pictime/job/${jobId}/gallery/import`;
		return this.http.post<ServerDataResponse<null>>(
			url,
			selectedPicTimeGalleriesToSend
		);
	}

	createPicTimeGallery(
		jobId,
		galleryDetails: CreatePicTimeGallery
	): Observable<ServerDataResponse<GetRedirectPicTimeUrl>> {
		const url = `/api/user/pictime/job/${jobId}/gallery/create`;
		return this.http.post<ServerDataResponse<GetRedirectPicTimeUrl>>(
			url,
			galleryDetails
		);
	}

	deletePicTimeGallery(url): Observable<ServerDataResponse<null>> {
		return this.http.delete<ServerDataResponse<null>>(url);
	}

	getJobMetadata(jobId): Observable<ServerDataResponse<JobMetadata>> {
		const url = `/api/user/pictime/job/${jobId}/metadata`;
		return this.http.get<ServerDataResponse<JobMetadata>>(url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/integrations/pickTime/pickTime.data.service.ts